// @ts-nocheck
import React from "react";
import { createPortal } from "react-dom";
import DatasetVisibilityModal from "../DatasetVisibilityModal";
import TimeRangeModal from "../TimeRangeModal";

// Component to manage and render graph-related modals
const GraphModals = ({
  isDatasetOpen,
  isTimeRangeOpen,
  onCloseDataset,
  onCloseTimeRange,
  datasets,
  onToggleVisibility,
  timeRanges,
  selectedTimeRange,
  onSelectTimeRange,
  timeZone,
  onTimeZoneSelect,
  assetTimeZone,
  timeZoneMode,
}) => {
  const portalTarget = typeof document !== "undefined" ? document.body : null;
  if (!portalTarget) return null;

  return createPortal(
    <>
      <DatasetVisibilityModal
        isOpen={isDatasetOpen}
        onClose={onCloseDataset}
        datasets={datasets}
        onToggleVisibility={onToggleVisibility}
      />
      <TimeRangeModal
        isOpen={isTimeRangeOpen}
        onClose={onCloseTimeRange}
        options={timeRanges}
        selectedValue={selectedTimeRange}
        onSelectTimeRange={onSelectTimeRange}
        timeZone={timeZone}
        onTimeZoneSelect={onTimeZoneSelect}
        assetTimeZone={assetTimeZone}
        timeZoneMode={timeZoneMode}
      />
    </>,
    portalTarget
  );
};

export default GraphModals;
